import React from 'react';
import AppRouter from './Router';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <div className="App">
      <AppRouter />
      <ScrollToTop />
    </div>
  );
}

export default App;
